import { render, staticRenderFns } from "./BatchesSchedules.vue?vue&type=template&id=6d957ec7"
import script from "./BatchesSchedules.vue?vue&type=script&lang=js"
export * from "./BatchesSchedules.vue?vue&type=script&lang=js"
import style0 from "./BatchesSchedules.vue?vue&type=style&index=0&id=6d957ec7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports